import pluralize from "pluralize";

const PRESERVED_UNIT_CODES = new Set(["nos"]);

function normalizeQuantity(quantity) {
    if (quantity === null || quantity === undefined || quantity === "") {
        return null;
    }
    const normalized = typeof quantity === "number"
        ? quantity
        : Number(String(quantity).replace(/,/g, ""));
    return Number.isFinite(normalized) ? normalized : null;
}

export function getMedicationUnitDisplay(unitDisplay, quantity) {
    const normalizedUnit = typeof unitDisplay === "string" ? unitDisplay.trim() : "";
    if (!normalizedUnit) {
        return "";
    }
    if (PRESERVED_UNIT_CODES.has(normalizedUnit.toLowerCase())) {
        return normalizedUnit;
    }
    const count = normalizeQuantity(quantity);
    if (count === null) {
        return normalizedUnit;
    }
    return pluralize(normalizedUnit, count);
}

export function buildMedicationQuantityLabel(quantity, unitDisplay) {
    const hasQuantity = quantity !== null && quantity !== undefined && quantity !== "";
    const quantityText = hasQuantity ? String(quantity) : "";
    const unitText = getMedicationUnitDisplay(unitDisplay, quantity);

    if (!quantityText && !unitText) {
        return "";
    }
    if (!quantityText) {
        return unitText;
    }
    if (!unitText) {
        return quantityText;
    }
    return `${quantityText} ${unitText}`;
}
